import * as views from '../views';
import NewHomepage from '../views/NewHomepage';

export interface AppRoute {
  title: string;
  path?: string;
  Component: any;
  exact?: boolean;
  key?: number;
}

export const routes: AppRoute[] = [
  {
    title: 'Homepage',
    path: '/',
    Component: NewHomepage,
    exact: true,
  },
  {
    title: 'FPVOne',
    path: '/fpvone',
    Component: views.FPVOne,
    exact: true,
  },
  {
    title: 'FPVConnect',
    path: '/fpvconnect',
    Component: views.FPVConnect,
    exact: true,
  },
  {
    title: 'FPVHeadsets-details',
    path: '/fpvdetails/:id',
    Component: views.FPVDetails,
  },
  {
    title: 'About',
    path: '/about',
    Component: views.About,
    exact: true,
  },
  {
    title: 'Company Culture',
    path: '/company-culture',
    Component: views.CompanyCulture,
    exact: true,
  },
  {
    title: 'Jobs',
    path: '/jobs',
    Component: views.Jobs,
    exact: true,
  },
  {
    title: 'Download',
    path: '/download',
    Component: views.Download,
    exact: true,
  },
  {
    title: 'Resellers',
    path: '/resellers',
    Component: views.Resellers,
    exact: true,
  },
  {
    title: 'Register',
    path: '/register',
    Component: views.Register,
    exact: true,
  },
  {
    title: 'Manual',
    path: '/manual',
    Component: views.Manual,
    exact: true,
  },
  {
    title: 'Downloads',
    path: '/downloads',
    Component: views.Downloads,
    exact: true,
  },
  {
    title: 'News',
    path: '/news/:filter?',
    Component: views.Blog,
    exact: true,
  },
  // {
  //   title: 'Products',
  //   path: '/products/:slug?',
  //   Component: views.Products,
  //   exact: true,
  // },
  {
    title: 'News details',
    path: '/news-details/:slug',
    Component: views.BlogDetails,
    exact: true,
  },
  // {
  //   title: 'Asda Contact Form',
  //   path: '/asda/contact',
  //   Component: views.AsdaForm,
  //   exact: true,
  // },
  {
    title: 'Drones-simulator',
    path: '/BRINCDrones-simulator',
    Component: views.BrincDronesSimulator,
    exact: true,
  },
  {
    title: 'FPVCtrl',
    path: '/products/fpvctrl',
    Component: views.FPVCtrl,
    exact: true,
  },
  {
    title: 'ESIF',
    path: '/eu-projects/esif',
    Component: views.ESIF,
    exact: true,
  },
  {
    title: 'EUInternationalization',
    path: '/eu-projects/eu-Internacionalizacija',
    Component: views.EUInternationalization,
    exact: true,
  },
  {
    title: 'EUInovationVouchers',
    path: '/eu-projects/eu-razvojna-ispitivanja',
    Component: views.EUInovationVouchers,
    exact: true,
  },
  {
    title: 'EUCyberSecurity',
    path: '/eu-projects/eu-kiberneticka-sigurnost',
    Component: views.EUCyberSecurity,
    exact: true,
  },
  {
    title: 'EUCyberSecurity',
    path: '/eu-projects/eu-bodycam-bluetooth',
    Component: views.EUBodyCamBluetooth,
    exact: true,
  },
  {
    title: 'EU1sCharger',
    path: '/eu-projects/eu-1s-charger',
    Component: views.EUCharger,
    exact: true,
  },
  {
    title: 'Privacy Policy',
    path: '/privacy-policy',
    Component: views.PrivacyPolicy,
  },
  {
    title: 'FPVOnePilot',
    path: '/products/fpvonepilot',
    Component: views.FPVOnePilot,
    exact: true,
  },
  // {
  //   title: 'FPVOneRace',
  //   path: '/products/fpvonerace',
  //   Component: views.FPVOneRace,
  //   exact: true,
  // },
  { title: 'Pilots', path: '/pilots', Component: views.Pilots, exact: true },
  {
    title: 'FPVAce',
    path: '/products/fpv-ace',
    Component: views.FPVAce,
    exact: true,
  },
  // {
  //   title: 'DreamX',
  //   path: '/products/dreamx',
  //   Component: views.DreamX,
  //   exact: true,
  // },
  {
    title: 'PowerMeterV2',
    path: '/products/power-meter-v2',
    Component: views.PowerMeterV2,
    exact: true,
  },
  // {
  //   title: 'LapRf',
  //   path: '/products/lap-rf',
  //   Component: views.LapRf,
  //   exact: true,
  // },
  { title: 'SkyDive', path: '/products/skydive', Component: views.Skydive },
  {
    title: 'RapidFire',
    path: '/products/rapid-fire',
    Component: views.RapidFire,
  },
  {
    title: 'DroneSoccer',
    path: '/products/drone-soccer',
    Component: views.DroneSoccer,
  },
  {
    title: 'Mrm1-5',
    path: '/products/mrm1-5',
    Component: views.Mrm1,
  },
  {
    title: 'Mrm2-10',
    path: '/products/mrm2-10',
    Component: views.Mrm2,
  },
  {
    title: 'H7 Wingcore',
    path: '/products/h7-wingcore',
    Component: views.Wingcore,
  },
  // { title: 'Defense', path: '/asda', Component: views.Defense, exact: true },
  {
    title: 'Contact',
    path: '/contact',
    Component: views.ContactForm,
    exact: true,
  },
  {
    title: 'enterprise',
    path: '/enterprise',
    Component: views.Enterprise,
    exact: true,
  },
  { title: 'Defense', path: '/defense', Component: views.Auvsi, exact: true },
  {
    title: 'OrqaDeveloperProgram',
    path: '/developer-program',
    Component: views.OrqaDeveloperProgram,
    exact: true,
  },
  {
    title: 'Defense Sim',
    path: '/defense-sim',
    Component: () => null,
    exact: true,
  },
  { title: '404', path: '*', Component: views.Error404, exact: true },
];
